module.exports = __webpack_public_path__ + "img/right_1.13647e42.jpg";